import { render, staticRenderFns } from "./home.vue?vue&type=template&id=1bd85acb&scoped=true&"
import script from "./home.vue?vue&type=script&lang=js&"
export * from "./home.vue?vue&type=script&lang=js&"
import style0 from "./home.vue?vue&type=style&index=0&id=1bd85acb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bd85acb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\workspace\\uat\\platform-uat\\Platform-foundation-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1bd85acb')) {
      api.createRecord('1bd85acb', component.options)
    } else {
      api.reload('1bd85acb', component.options)
    }
    module.hot.accept("./home.vue?vue&type=template&id=1bd85acb&scoped=true&", function () {
      api.rerender('1bd85acb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sqlPage/home.vue"
export default component.exports